import { AbstractControl } from '@angular/forms';

export function ValueValidator(control: AbstractControl): { [key: string]: boolean } | null  {
  if (+control.value == 0) {
    return { validValue: true };
  }
  return null;
}

